import React from "react";
import { connect } from "react-redux";
import { withAlert } from "react-alert";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Header from "../Header/header";
import PlanPage from "../signup/planPage";
import {
  planPriceChange,
  clearPlanData,
  getAffiliateDetailByAffiliateKey
} from "../../Actions/actions";
import loader from "../../images/Spin-1s-107px.gif";

class ChangePlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      planChanged: false,
      BusinessUserProfileDataPlanLis: [],
      plansDataAffiliate1: [],
      AllPlansForMemberAfi: [],
      plainDetailData: {},
      isLoader: false,
      intervalId: 0
    };
    // this.handleNav();
  }

  componentDidMount() {
    const { clearPlanData } = this.props
    clearPlanData();
  }
  componentWillMount() {
    const { BusinessUserProfileData } = this.props.data;

    this.setState({
      BusinessUserProfileDataPlanLis: [],
      plansDataAffiliate1: [],
      AllPlansForMemberAfi: []
    });

    if (
      BusinessUserProfileData.affiliateKey &&
      BusinessUserProfileData.affiliateKey !== undefined &&
      BusinessUserProfileData.affiliateKey !== "undefined"
    ) {
      this.setState({
        isLoader: true
      });
      this.props.getAffiliateDetailByAffiliateKey(
        BusinessUserProfileData.affiliateKey
      );
    }
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.setState({
      intervalId
    });
  }
  // handleNav = () => {
  //   this.props.disableNav();
  // }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  onPlanSelectBar = async (id, selectedPlanAmount, planData) => {
    // const data = {
    //   userId: this.props.data.userInfo.userObject.userDto.userId,
    //   planPriceId: id,
    // };

    let data;
    if (
      planData.planName !== "Basic" &&
      planData.planName !== "Basic Outsourced" &&
      planData.planName !== "Basic Automatic"
    ) {
      data = {
        userId: this.props.data.userInfo.userObject.userDto.userId,
        planPriceId: id,
        paymentStatus: "pending",
        selectedPlanName: planData.planName,
        selectedPlanAmount
      };

    } else {
      data = {
        userId: this.props.data.userInfo.userObject.userDto.userId,
        planPriceId: id,
        paymentStatus: "paid",
        selectedPlanName: planData.planName,
        selectedPlanAmount
      };

    }
    this.setState({ planChanged: true });

    await this.props.planPriceChange(data);
  };

  // componentDidUpdate() {
  //   console.log('componentDidUpdate');
  // }

  // async componentWillReceiveProps(nextProps: Readonly<P>): void {
  //   if (this.state.planChanged === true) {

  //     if (nextProps.data.planUpdate && nextProps.data.planUpdate.paymentStatus !== "paid") {
  //       await localStorage.setItem(
  //         "fusebillPlanFrequencyId",
  //         nextProps.data.planUpdate.fusebillPlanFrequencyId
  //       );
  //       this.context.router.history.push("/add-payment-method");
  //     } else {
  //       this.context.router.history.push("/dashboard");
  //     }
  //   }
  // }

  componentDidUpdate() {
    const { BusinessUserProfileData, plansDataAffiliate, planUpdate } = this.props.data;
    const { BusinessUserProfileDataPlanLis, plansDataAffiliate1, plainDetailData } = this.state;
    const plainDto = {};

    // console.log('planUpdate.paymentStatus', planUpdate)

    if (plainDetailData !== planUpdate) {

      if (planUpdate && planUpdate.paymentStatus) {

        // console.log('planUpdate.paymentStatus', planUpdate.paymentStatus)
        if (planUpdate.paymentStatus !== "paid") {
          localStorage.setItem(
            "fusebillPlanFrequencyId",
            planUpdate.fusebillPlanFrequencyId
          );
          this.context.router.history.push("/add-payment-method");
        } else {
          this.context.router.history.push("/dashboard");
        }
        this.setState({
          plainDetailData: planUpdate
        })

      }
    }

    if (
      BusinessUserProfileData.affiliateKey &&
      BusinessUserProfileData.affiliateKey !== undefined &&
      BusinessUserProfileData.affiliateKey !== "undefined"
    ) {
      if (BusinessUserProfileDataPlanLis !== BusinessUserProfileData) {
        this.setState({
          BusinessUserProfileDataPlanLis: BusinessUserProfileData,
          isLoader: true
        });
        this.props.getAffiliateDetailByAffiliateKey(
          BusinessUserProfileData.affiliateKey
        );
      }
    }

    if (plansDataAffiliate !== undefined) {
      if (plansDataAffiliate.result !== undefined) {
        if (plansDataAffiliate.result.affiliateActive === 1) {
          if (plansDataAffiliate1 !== plansDataAffiliate) {
            Object.assign(plainDto, {
              records: plansDataAffiliate.result.affiliateSubscriptionDto.map
            });
            this.setState({
              plansDataAffiliate1: plansDataAffiliate,
              AllPlansForMemberAfi: plainDto,
              isLoader: false
            });
          }
        }
      }
    }
  }

  render() {
    const {
      enterpriseType,
      totalTaxId
    } = this.props.data.userInfo.userObject.userDto;
    const { AllPlansForMember, BusinessUserProfileData } = this.props.data;
    const { AllPlansForMemberAfi, isLoader } = this.state;
    // console.log(
    //   "BusinessUserProfileData.affiliateKey",
    //   AllPlansForMember,
    //   BusinessUserProfileData.affiliateKey
    // );
    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    return (
      <span>
        {loader1}

        <div className="container">
          <div className="main-content">
            <Header />
            <div className="white-box">
              <div className="row">
                <div className="col s12 m12 pad-none">
                  <div className="row">
                    <PlanPage
                      plainDetail={
                        BusinessUserProfileData.affiliateKey &&
                          BusinessUserProfileData.affiliateKey !== "" &&
                          BusinessUserProfileData.affiliateKey !== "undefined"
                          ? AllPlansForMemberAfi
                          : AllPlansForMember
                      }
                      onPlanSelect={this.onPlanSelectBar}
                      enterpriseType={enterpriseType}
                      totalTaxId={totalTaxId}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

ChangePlan.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  data: state.data
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      planPriceChange,
      clearPlanData,
      getAffiliateDetailByAffiliateKey
    },
    dispatch
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ChangePlan)
);
